import Avatar from 'core/modules/atoms/Avatar';
import React, { useEffect, useRef } from 'react';

import type { StudentQuadrantData } from '../types';

import './_student-cluster-tooltip.scss';

type StudentClusterTooltipProps = {
  onClose: () => void;
  onStudentClick?: (student: StudentQuadrantData) => void;
  position: { x: number; y: number };
  students: StudentQuadrantData[];
};

function StudentClusterTooltip({ onClose, onStudentClick, position, students }: StudentClusterTooltipProps): JSX.Element {
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent): void {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="student-cluster-tooltip" ref={tooltipRef} style={{ left: position.x, top: position.y - 12 }}>
      <div className="student-cluster-tooltip__list">
        {students.map((student) => (
          <div
            className={`student-cluster-tooltip__row ${onStudentClick ? 'student-cluster-tooltip__row--clickable' : ''}`}
            key={student.userId}
            onClick={
              onStudentClick
                ? () => {
                    onStudentClick(student);
                    onClose();
                  }
                : undefined
            }
          >
            <Avatar image={student.avatar || undefined} size="small" />
            <span className="student-cluster-tooltip__name">
              {student.name} {student.lastName}
            </span>
          </div>
        ))}
      </div>
      <div className="student-cluster-tooltip__arrow" />
    </div>
  );
}

export default StudentClusterTooltip;
